import {
	Directive,
	Input,
	OnChanges,
	SimpleChanges,
	TemplateRef,
	ViewContainerRef
} from "@angular/core";
import { SkeletonComponent } from "@shared/components/atlas/skeleton/skeleton.component";

@Directive({
	selector: "[appSkeleton]"
})
export class SkeletonDirective implements OnChanges {
	@Input() appSkeleton = false;
	@Input() appSkeletonCount = 1;
	@Input() appSkeletonWidth = "100%";
	@Input() appSkeletonMinWidth = "100%";
	@Input() appSkeletonHeight = "20px";
	@Input() appSkeletonClassName = "";
	@Input() appSkeletonCircle = false;
	@Input() appSkeletonEnableAnimation = true;

	constructor(
		private templateRef: TemplateRef<unknown>,
		private viewContainer: ViewContainerRef
	) {}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.appSkeleton) {
			this.viewContainer.clear();
			if (changes.appSkeleton.currentValue) {
				Array.from({ length: this.appSkeletonCount }).forEach(() => {
					const componentRef =
						this.viewContainer.createComponent(SkeletonComponent);
					Object.assign(componentRef.instance, {
						width: this.appSkeletonWidth,
						minWidth: this.appSkeletonMinWidth,
						height: this.appSkeletonHeight,
						className: this.appSkeletonClassName,
						circle: this.appSkeletonCircle,
						enableAnimation: this.appSkeletonEnableAnimation
					});
				});
				return;
			}
			this.viewContainer.createEmbeddedView(this.templateRef);
		}
	}
}
